import { httpCreate } from './http';
const http = httpCreate('/srv/feedback');
export const feedback = {
	getAll(params, data) {
		return http.post('/getAll', data, { params });
	},
	getById(id) {
		return http.get(`/getById/${id}`);
	}
};
